import React from 'react';
import { Navigate } from 'react-router-dom';
import useStudentAuth from '../../../hooks/useStudentAuth';

export default function StudentProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useStudentAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/student/login" replace />;
  }

  return children;
}